import React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { Texte } from "../../utils/style/elements.tsx";


const ListContainer = styled.div<{ $centered?: boolean }>`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(285px, 1fr));
    gap: 20px;
    margin-top: 20px;
    justify-content: ${({ $centered }) => ($centered ? "center" : "start")};
    align-items: flex-start;
    justify-items: center;

    @media (min-width: 1750px) {
        margin-top: 20px; 
        justify-content: ${({ $centered }) => ($centered ? "center" : "start")}; 
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        gap: 2vw;
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fit, minmax(285px, 2fr));
        justify-items: center;
    }
`;


// const ListContainer = styled.div<{ $centered?: boolean }>`

//     // background-color: red; 
//     margin-top: 20px; 
//     justify-content: ${({ $centered }) => ($centered ? "center" : "start")}; 
//     align-items: flex-start; 
//     display: flex;
//     flex-wrap: wrap;
//     gap: 1.5vw;

//     @media (max-width: 768px) { 
//         justify-content: center; 
//     }
        

// `;


// 
// 
// 
// @media (max-width: 900px) {
//     grid-template-columns: repeat(2, 1fr);
// }
// @media (max-width: 600px) {
//     grid-template-columns: 1fr;
// }


const ProjectItem = styled.div`
    padding: 10px;
    text-align: center;
    width: 285px;

    @media (max-width: 768px) {
        width: 230px;
    }
`

const ProjectImage = styled.img`
    width: 285px;
    height: 225px;
    display: block;
    margin: 0 auto;
    cursor: pointer;
    box-shadow: 5px 5px 5px #0000007a;
    margin-bottom: 10px;

    transition: all ease 0.3s;

    &:hover{
        transition: all ease 0.3s;
        transform: translate(-10px, -10px);
        box-shadow: 10px 10px 10px gray;
    }

    @media (max-width: 768px) {
        width: 230px;
        height: 180px;
    }
`

const Text = styled.div`
    margin-bottom: 20px;
`


const StyledTexte = styled(Texte)`
    margin: 0;
    font-size: 20px;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

function ProjectList({ projects, centered = false }: 
    { projects: { 
        slug?: string; 
        image: string; 
        texte: string; 
        sousTexte: string 
        }[]; 
      centered?: boolean;
    }) 
{
    return (
        <ListContainer $centered={centered}>
            {projects.map((project) => (
                <ProjectItem key={project.slug || project.image}>
                    {project.slug ? (
                        <Link to={`/${project.slug}`}>
                            <ProjectImage src={project.image} alt={project.texte} />
                        </Link>
                    ) : (
                        <ProjectImage 
                            src={project.image} 
                            alt={project.texte} 
                            style={{ cursor: "default" }} 
                        />
                    )}
                    <Text>
                        <b><StyledTexte>{project.texte}</StyledTexte></b>
                        <StyledTexte>{project.sousTexte}</StyledTexte>
                    </Text>
                </ProjectItem>
            ))}
        </ListContainer>
    )
}

export default ProjectList
